export default {
	getPresets: {
		useCache: false,
		apiServiceMethodName: 'getPresets',
	},
	getMultiplePresets: {
		useCache: false,
		apiServiceMethodName: 'getMultiplePresets',
	},
	deletePreset: {
		useCache: false,
		apiServiceMethodName: 'deletePreset',
	},
	editPreset: {
		useCache: false,
		apiServiceMethodName: 'editPreset',
	},
	patchPreset: {
		useCache: false,
		apiServiceMethodName: 'patchPreset',
	},
	createPreset: {
		useCache: false,
		apiServiceMethodName: 'createPreset',
	},
	cloneToCompanyPreset: {
		useCache: false,
		apiServiceMethodName: 'cloneToCompanyPreset',
	},
	changePresetsOrder: {
		useCache: false,
		apiServiceMethodName: 'changePresetsOrder',
	},
}
